import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (

<div className="container mx-auto p-8">
      <div className="bg-white rounded-lg mt-8 shadow-lg p-6 border border-gray-400">
        <div className="mb-6">
          <div className="text-6xl font-bold text-gray-300 mb-4">404</div>
          <h1 className="text-2xl font-bold text-gray-800 mb-2">Page Not Found</h1>
          <p className="text-gray-600 mb-6">
            Sorry, the page you're looking for doesn't exist or has been moved.
          </p>
        </div>
        
        <div className="space-y-4">
          <Link 
            to="/" 
            className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200"
          >
            <i className="fas fa-home mr-2"></i>
            Go to Homepage
          </Link>
          
          <div className="text-sm text-gray-500">
            <p>Or try one of these pages:</p>
            <div className="flex flex-wrap justify-center gap-4 mt-3">
              <Link to="/about" className="text-blue-600 hover:text-blue-800 hover:underline">
                About
              </Link>
              <Link to="/community" className="text-blue-600 hover:text-blue-800 hover:underline">
                Community
              </Link>
              <Link to="/subscribe" className="text-blue-600 hover:text-blue-800 hover:underline">
                Subscribe
              </Link>
            </div>
          </div>
        </div>
        
        
      </div>
      
    </div>

  );
};

export default NotFound; 